"use client"

import React from "react"

import { useState } from "react"
import { MessageCircle, X } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Textarea } from "@/components/ui/textarea"
import { Label } from "@/components/ui/label"

export function WhatsAppButton() {
  const [isOpen, setIsOpen] = useState(false)
  const [formData, setFormData] = useState({
    nome: "",
    telefone: "",
    mensagem: "",
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    
    const whatsappNumber = "5511999999999" // Substitua pelo numero real
    const text = `Olá! Meu nome é ${formData.nome}.%0A%0ATelefone: ${formData.telefone}%0A%0AMensagem: ${formData.mensagem}`
    
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${text}`
    window.open(whatsappUrl, "_blank")
    
    setIsOpen(false)
    setFormData({ nome: "", telefone: "", mensagem: "" })
  }

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Chat Form */}
      {isOpen && (
        <div className="absolute bottom-20 right-0 w-80 bg-card border border-border rounded-2xl shadow-2xl overflow-hidden animate-in slide-in-from-bottom-5 fade-in duration-300">
          <div className="bg-primary p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-primary-foreground/20 rounded-full flex items-center justify-center">
                  <MessageCircle className="w-5 h-5 text-primary-foreground" />
                </div>
                <div>
                  <h3 className="font-semibold text-primary-foreground">TRD Solutions</h3>
                  <p className="text-xs text-primary-foreground/80">Responde em minutos</p>
                </div>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
          
          <form onSubmit={handleSubmit} className="p-4 flex flex-col gap-3">
            <div className="flex flex-col gap-1">
              <Label htmlFor="wpp-nome" className="text-foreground text-sm">Nome</Label>
              <Input
                id="wpp-nome"
                placeholder="Seu nome"
                value={formData.nome}
                onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
                required
                className="bg-secondary border-border text-foreground placeholder:text-muted-foreground h-9"
              />
            </div>
            <div className="flex flex-col gap-1">
              <Label htmlFor="wpp-telefone" className="text-foreground text-sm">Telefone</Label>
              <Input
                id="wpp-telefone"
                placeholder="(11) 99999-9999"
                value={formData.telefone}
                onChange={(e) => setFormData({ ...formData, telefone: e.target.value })}
                required
                className="bg-secondary border-border text-foreground placeholder:text-muted-foreground h-9"
              />
            </div>
            <div className="flex flex-col gap-1">
              <Label htmlFor="wpp-mensagem" className="text-foreground text-sm">Mensagem</Label>
              <Textarea
                id="wpp-mensagem"
                placeholder="Como podemos ajudar?"
                value={formData.mensagem}
                onChange={(e) => setFormData({ ...formData, mensagem: e.target.value })}
                required
                rows={2}
                className="bg-secondary border-border text-foreground placeholder:text-muted-foreground resize-none"
              />
            </div>
            <Button type="submit" className="w-full bg-[#25D366] hover:bg-[#20BD5A] text-white gap-2 mt-1">
              <MessageCircle className="w-4 h-4" />
              Iniciar Conversa
            </Button>
          </form>
        </div>
      )}

      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="relative w-14 h-14 bg-[#25D366] hover:bg-[#20BD5A] rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 group"
        aria-label="Abrir WhatsApp"
      >
        {/* Pulse Animation */}
        <span className="absolute w-full h-full rounded-full bg-[#25D366] animate-ping opacity-30" />
        <span className="absolute w-full h-full rounded-full bg-[#25D366] animate-pulse opacity-20" />
        
        <MessageCircle className="w-7 h-7 text-white relative z-10 transition-transform duration-300 group-hover:rotate-12" />
      </button>
    </div>
  )
}
